import { render, staticRenderFns } from "./FileDistribution.vue?vue&type=template&id=fe81eb5a&scoped=true"
import script from "./FileDistribution.vue?vue&type=script&lang=js"
export * from "./FileDistribution.vue?vue&type=script&lang=js"
import style0 from "./FileDistribution.vue?vue&type=style&index=0&id=fe81eb5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe81eb5a",
  null
  
)

export default component.exports